{
 "areas": [
  {
   "id": "z06-toll-shelter",
   "name": "Toll Shelter",
   "zone": "Z06",
   "beatId": "beat:z06-toll-shelter",
   "anchor": [
    768,
    480
   ],
   "image": "/assets/painted/z06-toll-shelter.webp",
   "width": 1536,
   "height": 1024,
   "spawn": [
    960,
    640
   ],
   "arrival": [
    960,
    640
   ],
   "walkable": [
    [
     [
      240,
      90
     ],
     [
      470,
      150
     ],
     [
      480,
      235
     ],
     [
      640,
      325
     ],
     [
      700,
      345
     ],
     [
      870,
      450
     ],
     [
      1040,
      480
     ],
     [
      1090,
      540
     ],
     [
      1250,
      578
     ],
     [
      1400,
      618
     ],
     [
      1536,
      650
     ],
     [
      1536,
      1024
     ],
     [
      1080,
      1024
     ],
     [
      900,
      830
     ],
     [
      755,
      670
     ],
     [
      610,
      550
     ],
     [
      500,
      455
     ],
     [
      355,
      310
     ],
     [
      300,
      225
     ]
    ]
   ],
   "blocked": [
    [
     [
      530,
      400
     ],
     [
      572,
      400
     ],
     [
      572,
      495
     ],
     [
      530,
      495
     ]
    ],
    [
     [
      826,
      340
     ],
     [
      866,
      340
     ],
     [
      866,
      440
     ],
     [
      826,
      440
     ]
    ],
    [
     [
      1355,
      660
     ],
     [
      1405,
      660
     ],
     [
      1405,
      745
     ],
     [
      1355,
      745
     ]
    ],
    [
     [
      1425,
      580
     ],
     [
      1475,
      580
     ],
     [
      1475,
      690
     ],
     [
      1425,
      690
     ]
    ],
    [
     [
      1490,
      745
     ],
     [
      1536,
      745
     ],
     [
      1536,
      800
     ],
     [
      1490,
      800
     ]
    ]
   ],
   "foregrounds": [
    {
     "polygon": [
      [
       530,
       395
      ],
      [
       572,
       395
      ],
      [
       572,
       495
      ],
      [
       530,
       495
      ]
     ],
     "depth": 495
    }
   ],
   "lamps": [
    [
     460,
     190
    ],
    [
     590,
     175
    ],
    [
     795,
     235
    ],
    [
     940,
     310
    ],
    [
     1030,
     355
    ],
    [
     1170,
     415
    ],
    [
     1430,
     495
    ],
    [
     495,
     425
    ],
    [
     155,
     595
    ]
   ],
   "water": [
    [
     [
      260,
      800
     ],
     [
      420,
      780
     ],
     [
      520,
      870
     ],
     [
      540,
      1024
     ],
     [
      300,
      1024
     ],
     [
      250,
      900
     ]
    ]
   ],
   "smoke": [
    [
     460,
     180
    ],
    [
     495,
     415
    ]
   ],
   "people": [
    {
     "id": "person:z06-toll-shelter-0",
     "appearance": "actor-z06-toll-guard",
     "name": "Compact toll guard",
     "route": [
      [
       700,
       480
      ],
      [
       900,
       560
      ]
     ]
    },
    {
     "id": "person:z06-toll-shelter-1",
     "appearance": "actor-waiting-family",
     "name": "Traveller at the stalls",
     "route": [
      [
       980,
       660
      ],
      [
       1180,
       700
      ]
     ]
    }
   ],
   "landmarks": [
    {
     "id": "beat:z06-broken-span",
     "label": "Road on to the broken span",
     "toBeat": "beat:z06-broken-span",
     "at": [
      384,
      192
     ],
     "text": "Past the scaffold, the road runs out onto the causeway and the plank bridge."
    },
    {
     "id": "beat:z06-old-ford",
     "label": "Steps down to the ford",
     "toBeat": "beat:z06-old-ford",
     "at": [
      704,
      576
     ],
     "text": "A lamp-lit stair goes down over the wall to the ravine and the old ford."
    },
    {
     "id": "z06-caldris-road",
     "label": "Road back to Caldris",
     "at": [
      1408,
      896
     ],
     "text": "The west imperial road runs back to Caldris. Forty-four kilometres, and every one of them is paid for somewhere.",
     "toBeat": "beat:z01-river-bridge"
    },
    {
     "id": "z06-toll-table",
     "label": "The toll table",
     "at": [
      640,
      352
     ],
     "text": "A beam scale, a strongbox and a tablet of rates. The rate for repair is written larger than the rate for passage."
    },
    {
     "id": "z06-toll-chain",
     "label": "The toll chain",
     "at": [
      704,
      448
     ],
     "text": "The chain is up. It comes down for coin, or for a lease-holder's word."
    },
    {
     "id": "z06-roadside-stalls",
     "label": "The roadside stalls",
     "at": [
      1088,
      560
     ],
     "text": "Wool, lentils, rope and sandals, priced for people who have already paid once today."
    }
   ],
   "props": [
    {
     "id": "z06-coffin-wagon",
     "image": "/assets/painted/props/z06-coffin-wagon.png",
     "at": [
      1040,
      585
     ],
     "height": 175,
     "when": {
      "all": [
       "z06:coffin-cart"
      ],
      "any": [],
      "none": [
       "z06:coffins-passed",
       "z06:coffins-held",
       "z06:carts-across"
      ]
     }
    },
    {
     "id": "z06-lime-cart-1",
     "image": "/assets/painted/props/z06-lime-cart.png",
     "at": [
      900,
      520
     ],
     "height": 110,
     "when": {
      "all": [
       "z06:carts-across"
      ],
      "any": [],
      "none": [
       "z06:arch-closed",
       "z06:guard-beaten"
      ]
     }
    },
    {
     "id": "z06-lime-cart-2",
     "image": "/assets/painted/props/z06-lime-cart.png",
     "at": [
      1010,
      575
     ],
     "height": 110,
     "when": {
      "all": [
       "z06:carts-across"
      ],
      "any": [],
      "none": [
       "z06:arch-closed",
       "z06:guard-beaten"
      ]
     }
    },
    {
     "id": "z06-lime-cart-3",
     "image": "/assets/painted/props/z06-lime-cart.png",
     "at": [
      1120,
      630
     ],
     "height": 110,
     "when": {
      "all": [
       "z06:carts-across"
      ],
      "any": [],
      "none": [
       "z06:arch-closed",
       "z06:guard-beaten"
      ]
     }
    },
    {
     "id": "z06-lime-cart-4",
     "image": "/assets/painted/props/z06-lime-cart.png",
     "at": [
      1230,
      685
     ],
     "height": 110,
     "when": {
      "all": [
       "z06:carts-across"
      ],
      "any": [],
      "none": [
       "z06:arch-closed",
       "z06:guard-beaten"
      ]
     }
    },
    {
     "id": "z06-coffin-row",
     "image": "/assets/painted/props/z06-coffin-row.png",
     "at": [
      760,
      330
     ],
     "height": 105,
     "when": {
      "all": [
       "z06:coffins-held"
      ],
      "any": [],
      "none": []
     }
    }
   ],
   "objects": [
    {
     "id": "z06-toll-coffin-wagon",
     "beatId": "beat:z06-toll-shelter",
     "name": "The covered wagon",
     "at": [
      1040,
      585
     ],
     "radius": 50,
     "actions": [
      "z06-carter-ask",
      "z06-coffins-look",
      "z06-coffins-cover"
     ],
     "look": "A carter’s wagon under oiled canvas, waiting its turn at the chain."
    },
    {
     "id": "z06-toll-chain-object",
     "beatId": "beat:z06-toll-shelter",
     "name": "The toll chain",
     "at": [
      704,
      430
     ],
     "radius": 40,
     "actions": [
      "z06-chain-force",
      "z06-carts-through"
     ],
     "look": "The chain is up. It comes down for coin, or for a lease-holder's word."
    }
   ]
  },
  {
   "id": "z06-broken-span",
   "name": "Broken Span",
   "zone": "Z06",
   "beatId": "beat:z06-broken-span",
   "anchor": [
    736,
    320
   ],
   "image": "/assets/painted/z06-broken-span.webp",
   "width": 1536,
   "height": 1024,
   "spawn": [
    448,
    400
   ],
   "arrival": [
    448,
    400
   ],
   "walkable": [
    [
     [
      140,
      112
     ],
     [
      270,
      112
     ],
     [
      420,
      190
     ],
     [
      560,
      245
     ],
     [
      610,
      275
     ],
     [
      590,
      300
     ],
     [
      960,
      215
     ],
     [
      1100,
      185
     ],
     [
      1300,
      135
     ],
     [
      1536,
      78
     ],
     [
      1536,
      150
     ],
     [
      1200,
      228
     ],
     [
      1060,
      262
     ],
     [
      1000,
      265
     ],
     [
      620,
      360
     ],
     [
      560,
      410
     ],
     [
      427,
      472
     ],
     [
      205,
      422
     ],
     [
      262,
      372
     ],
     [
      262,
      262
     ],
     [
      267,
      212
     ],
     [
      200,
      190
     ],
     [
      140,
      190
     ]
    ],
    [
     [
      205,
      422
     ],
     [
      427,
      472
     ],
     [
      345,
      510
     ],
     [
      335,
      590
     ],
     [
      200,
      600
     ],
     [
      190,
      440
     ]
    ]
   ],
   "blocked": [
    [
     [
      262,
      262
     ],
     [
      395,
      262
     ],
     [
      395,
      358
     ],
     [
      262,
      358
     ]
    ],
    [
     [
      520,
      200
     ],
     [
      640,
      230
     ],
     [
      640,
      285
     ],
     [
      520,
      255
     ]
    ],
    [
     [
      258,
      488
     ],
     [
      292,
      488
     ],
     [
      292,
      572
     ],
     [
      258,
      572
     ]
    ]
   ],
   "foregrounds": [],
   "lamps": [
    [
     540,
     215
    ],
    [
     640,
     345
    ],
    [
     1000,
     212
    ],
    [
     1418,
     42
    ],
    [
     1072,
     120
    ],
    [
     1258,
     608
    ],
    [
     1245,
     776
    ],
    [
     1412,
     646
    ],
    [
     215,
     552
    ],
    [
     100,
     530
    ],
    [
     18,
     528
    ]
   ],
   "water": [
    [
     [
      770,
      420
     ],
     [
      860,
      420
     ],
     [
      1000,
      600
     ],
     [
      1050,
      720
     ],
     [
      1180,
      880
     ],
     [
      1300,
      1024
     ],
     [
      900,
      1024
     ],
     [
      950,
      900
     ],
     [
      880,
      760
     ],
     [
      800,
      600
     ]
    ]
   ],
   "smoke": [
    [
     1175,
     140
    ],
    [
     215,
     540
    ]
   ],
   "people": [
    {
     "id": "person:z06-broken-span-0",
     "appearance": "actor-z06-causeway-labourer",
     "name": "Labourer on the planks",
     "route": [
      [
       660,
       340
      ],
      [
       900,
       265
      ]
     ]
    },
    {
     "id": "person:z06-broken-span-1",
     "appearance": "actor-z06-toll-guard",
     "name": "Compact guard",
     "route": [
      [
       300,
       430
      ],
      [
       480,
       380
      ]
     ]
    }
   ],
   "landmarks": [
    {
     "id": "beat:z06-toll-shelter",
     "label": "Road back to the toll shelter",
     "toBeat": "beat:z06-toll-shelter",
     "at": [
      224,
      520
     ],
     "text": "The road runs back past the customs house to the toll chain."
    },
    {
     "id": "beat:z06-repair-camp",
     "label": "Across to the repair camp",
     "toBeat": "beat:z06-repair-camp",
     "at": [
      1440,
      128
     ],
     "text": "Past the hoist, the contractor has pitched her camp by the road."
    },
    {
     "id": "beat:z06-old-ford",
     "label": "Scaffold ladder down to the ford",
     "toBeat": "beat:z06-old-ford",
     "at": [
      1328,
      200
     ],
     "text": "Past the hoist, a ladder goes down the scaffold to the ravine bed and the old ford."
    },
    {
     "id": "z06-plank-bridge",
     "label": "The plank bridge",
     "at": [
      784,
      288
     ],
     "text": "One cart at a time. The planks are new; the trestles under them are not."
    },
    {
     "id": "z06-slumped-wall",
     "label": "The burst retaining wall",
     "at": [
      544,
      400
     ],
     "text": "The fill behind the wall came out all at once. The arch stones lie where they fell, numbered in chalk."
    }
   ]
  },
  {
   "id": "z06-repair-camp",
   "name": "Repair Camp",
   "zone": "Z06",
   "beatId": "beat:z06-repair-camp",
   "anchor": [
    640,
    544
   ],
   "image": "/assets/painted/z06-repair-camp.webp",
   "width": 1536,
   "height": 1024,
   "spawn": [
    640,
    544
   ],
   "arrival": [
    640,
    544
   ],
   "walkable": [
    [
     [
      0,
      245
     ],
     [
      290,
      335
     ],
     [
      560,
      330
     ],
     [
      640,
      300
     ],
     [
      860,
      300
     ],
     [
      860,
      450
     ],
     [
      890,
      450
     ],
     [
      890,
      560
     ],
     [
      1000,
      620
     ],
     [
      1200,
      700
     ],
     [
      1300,
      730
     ],
     [
      1536,
      830
     ],
     [
      1536,
      1024
     ],
     [
      1340,
      1024
     ],
     [
      1140,
      870
     ],
     [
      900,
      760
     ],
     [
      640,
      660
     ],
     [
      560,
      640
     ],
     [
      150,
      505
     ],
     [
      0,
      400
     ]
    ],
    [
     [
      1380,
      250
     ],
     [
      1440,
      250
     ],
     [
      1450,
      380
     ],
     [
      1380,
      470
     ],
     [
      1330,
      560
     ],
     [
      1360,
      650
     ],
     [
      1340,
      765
     ],
     [
      1240,
      740
     ],
     [
      1270,
      600
     ],
     [
      1300,
      500
     ],
     [
      1370,
      400
     ],
     [
      1395,
      320
     ]
    ]
   ],
   "blocked": [
    [
     [
      690,
      360
     ],
     [
      770,
      360
     ],
     [
      770,
      410
     ],
     [
      690,
      410
     ]
    ],
    [
     [
      650,
      350
     ],
     [
      700,
      350
     ],
     [
      700,
      400
     ],
     [
      650,
      400
     ]
    ],
    [
     [
      770,
      345
     ],
     [
      830,
      345
     ],
     [
      830,
      390
     ],
     [
      770,
      390
     ]
    ],
    [
     [
      700,
      430
     ],
     [
      810,
      430
     ],
     [
      810,
      490
     ],
     [
      700,
      490
     ]
    ],
    [
     [
      650,
      430
     ],
     [
      690,
      430
     ],
     [
      690,
      500
     ],
     [
      650,
      500
     ]
    ],
    [
     [
      575,
      380
     ],
     [
      625,
      380
     ],
     [
      625,
      425
     ],
     [
      575,
      425
     ]
    ]
   ],
   "foregrounds": [],
   "lamps": [
    [
     620,
     240
    ],
    [
     1045,
     245
    ],
    [
     735,
     385
    ]
   ],
   "water": [
    [
     [
      0,
      900
     ],
     [
      330,
      880
     ],
     [
      330,
      1024
     ],
     [
      0,
      1024
     ]
    ]
   ],
   "smoke": [
    [
     1070,
     140
    ],
    [
     735,
     370
    ]
   ],
   "people": [
    {
     "id": "person:z06-repair-camp-0",
     "appearance": "actor-z06-causeway-labourer",
     "name": "Labourer with a barrow",
     "route": [
      [
       680,
       540
      ],
      [
       860,
       610
      ]
     ]
    },
    {
     "id": "person:z06-repair-camp-1",
     "appearance": "actor-kiln-worker",
     "name": "Lime burner",
     "route": [
      [
       560,
       450
      ],
      [
       640,
       470
      ]
     ]
    },
    {
     "id": "person:z06-repair-camp-2",
     "appearance": "actor-z06-toll-guard",
     "name": "Compact guard at the pay table",
     "route": [
      [
       500,
       380
      ],
      [
       560,
       360
      ]
     ]
    }
   ],
   "landmarks": [
    {
     "id": "beat:z06-broken-span",
     "label": "Back across the plank bridge",
     "toBeat": "beat:z06-broken-span",
     "at": [
      96,
      320
     ],
     "text": "The plank bridge goes back over the gap to the toll side."
    },
    {
     "id": "z06-western-road",
     "label": "Western road to Telvas",
     "at": [
      1472,
      928
     ],
     "text": "The road runs on west towards Telvas. Nobody here is going that way today."
    },
    {
     "id": "z06-quarry-road",
     "label": "Quarry road",
     "at": [
      1408,
      288
     ],
     "text": "The track climbs to the Dovren quarries. Stone comes down it; food goes up."
    },
    {
     "id": "z06-pay-table",
     "label": "The pay table",
     "at": [
      560,
      352
     ],
     "text": "Tally boards, a strongbox and a list of names. Most of the names have a bond mark beside them."
    },
    {
     "id": "z06-lime-kiln",
     "label": "The lime kiln",
     "at": [
      848,
      320
     ],
     "text": "The kiln has not been let cool in a month. The mortar for the new arch is burnt here."
    },
    {
     "id": "z06-cook-fire",
     "label": "The cook fire",
     "at": [
      736,
      432
     ],
     "text": "One pot for the whole gang. It smells of lentils and lime dust."
    }
   ],
   "props": [
    {
     "id": "z06-lime-cart-1",
     "image": "/assets/painted/props/z06-lime-cart.png",
     "at": [
      600,
      345
     ],
     "height": 95,
     "when": {
      "all": [],
      "any": [],
      "none": [
       "z06:carts-across"
      ]
     }
    },
    {
     "id": "z06-lime-cart-2",
     "image": "/assets/painted/props/z06-lime-cart.png",
     "at": [
      695,
      352
     ],
     "height": 95,
     "when": {
      "all": [],
      "any": [],
      "none": [
       "z06:carts-across"
      ]
     }
    },
    {
     "id": "z06-lime-cart-3",
     "image": "/assets/painted/props/z06-lime-cart.png",
     "at": [
      330,
      392
     ],
     "height": 95,
     "when": {
      "all": [],
      "any": [],
      "none": [
       "z06:carts-across"
      ]
     }
    },
    {
     "id": "z06-lime-cart-4",
     "image": "/assets/painted/props/z06-lime-cart.png",
     "at": [
      425,
      404
     ],
     "height": 95,
     "when": {
      "all": [],
      "any": [],
      "none": [
       "z06:carts-across"
      ]
     }
    }
   ]
  },
  {
   "id": "z06-old-ford",
   "name": "Old Ford",
   "zone": "Z06",
   "beatId": "beat:z06-old-ford",
   "anchor": [
    304,
    560
   ],
   "image": "/assets/painted/z06-old-ford.webp",
   "width": 1536,
   "height": 1024,
   "spawn": [
    304,
    560
   ],
   "arrival": [
    304,
    560
   ],
   "walkable": [
    [
     [
      40,
      62
     ],
     [
      110,
      55
     ],
     [
      200,
      140
     ],
     [
      280,
      235
     ],
     [
      330,
      300
     ],
     [
      320,
      335
     ],
     [
      250,
      380
     ],
     [
      270,
      440
     ],
     [
      330,
      505
     ],
     [
      560,
      560
     ],
     [
      780,
      630
     ],
     [
      960,
      645
     ],
     [
      1130,
      650
     ],
     [
      1300,
      740
     ],
     [
      1536,
      820
     ],
     [
      1536,
      1024
     ],
     [
      1300,
      1024
     ],
     [
      1100,
      930
     ],
     [
      900,
      800
     ],
     [
      760,
      750
     ],
     [
      560,
      700
     ],
     [
      420,
      690
     ],
     [
      260,
      640
     ],
     [
      240,
      560
     ],
     [
      180,
      480
     ],
     [
      140,
      400
     ],
     [
      170,
      340
     ],
     [
      210,
      300
     ],
     [
      130,
      210
     ],
     [
      60,
      130
     ]
    ],
    [
     [
      1020,
      540
     ],
     [
      1100,
      520
     ],
     [
      1250,
      540
     ],
     [
      1420,
      560
     ],
     [
      1460,
      620
     ],
     [
      1330,
      650
     ],
     [
      1180,
      665
     ],
     [
      1060,
      660
     ],
     [
      1000,
      640
     ]
    ]
   ],
   "blocked": [
    [
     [
      160,
      290
     ],
     [
      205,
      290
     ],
     [
      205,
      378
     ],
     [
      160,
      378
     ]
    ],
    [
     [
      1030,
      525
     ],
     [
      1215,
      560
     ],
     [
      1215,
      615
     ],
     [
      1030,
      580
     ]
    ],
    [
     [
      1240,
      515
     ],
     [
      1320,
      515
     ],
     [
      1320,
      570
     ],
     [
      1240,
      570
     ]
    ],
    [
     [
      1140,
      655
     ],
     [
      1300,
      655
     ],
     [
      1300,
      735
     ],
     [
      1140,
      735
     ]
    ],
    [
     [
      1360,
      720
     ],
     [
      1410,
      720
     ],
     [
      1410,
      800
     ],
     [
      1360,
      800
     ]
    ]
   ],
   "foregrounds": [],
   "lamps": [
    [
     80,
     80
    ],
    [
     185,
     200
    ],
    [
     305,
     330
    ],
    [
     1125,
     470
    ],
    [
     1325,
     470
    ],
    [
     1105,
     25
    ],
    [
     1275,
     85
    ]
   ],
   "water": [
    [
     [
      520,
      500
     ],
     [
      700,
      450
     ],
     [
      960,
      420
     ],
     [
      900,
      520
     ],
     [
      800,
      560
     ],
     [
      700,
      580
     ],
     [
      600,
      560
     ]
    ],
    [
     [
      360,
      720
     ],
     [
      560,
      710
     ],
     [
      780,
      760
     ],
     [
      760,
      800
     ],
     [
      500,
      790
     ],
     [
      420,
      760
     ]
    ]
   ],
   "smoke": [
    [
     1285,
     535
    ]
   ],
   "people": [
    {
     "id": "person:z06-old-ford-0",
     "appearance": "actor-waiting-family",
     "name": "Traveller at the camp",
     "route": [
      [
       1250,
       600
      ],
      [
       1400,
       610
      ]
     ]
    },
    {
     "id": "person:z06-old-ford-1",
     "appearance": "actor-heavy-labourer",
     "name": "Carter testing the ford",
     "route": [
      [
       800,
       700
      ],
      [
       1000,
       720
      ]
     ]
    }
   ],
   "landmarks": [
    {
     "id": "beat:z06-toll-shelter",
     "label": "Stair up to the toll shelter",
     "toBeat": "beat:z06-toll-shelter",
     "at": [
      112,
      96
     ],
     "text": "The lamp-lit stair climbs the ravine side to the road and the toll chain."
    },
    {
     "id": "beat:z06-broken-span",
     "label": "Scaffold ladder to the broken span",
     "toBeat": "beat:z06-broken-span",
     "at": [
      1392,
      592
     ],
     "text": "Behind the tents, a ladder climbs the scaffold to the plank bridge."
    },
    {
     "id": "z06-far-bank",
     "label": "Track to the far bank",
     "at": [
      1472,
      912
     ],
     "text": "The old track climbs out on the far side and rejoins the road beyond the toll."
    },
    {
     "id": "z06-stepping-stones",
     "label": "The stepping stones",
     "at": [
      656,
      656
     ],
     "text": "Cart ruts run straight into the water and out again. In a dry month it is shin-deep."
    },
    {
     "id": "z06-boundary-stone",
     "label": "The boundary stone",
     "at": [
      944,
      656
     ],
     "text": "A boundary stone older than the causeway. The ford was the road before the road was built."
    },
    {
     "id": "z06-travellers-camp",
     "label": "The travellers' camp",
     "at": [
      1312,
      608
     ],
     "text": "People who could not pay the toll, waiting for the water to stay low one more day."
    }
   ],
   "props": [
    {
     "id": "z06-ford-graves",
     "image": "/assets/painted/props/z06-ford-graves.png",
     "at": [
      520,
      420
     ],
     "height": 100,
     "when": {
      "all": [
       "past:z06:coffins-held"
      ],
      "any": [],
      "none": []
     }
    }
   ]
  }
 ]
}
